import { render, staticRenderFns } from "./young.vue?vue&type=template&id=ee36df22&scoped=true&"
import script from "./young.vue?vue&type=script&lang=js&"
export * from "./young.vue?vue&type=script&lang=js&"
import style0 from "./young.vue?vue&type=style&index=0&id=ee36df22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee36df22",
  null
  
)

export default component.exports